module.exports = __webpack_public_path__ + "static/grafika6@2x-7ffe9b2adec0fb457fb301a9757c19c2.png";